
  
// Script Généré le : 10/01/2026 10:38:10 via ModelGenerator.nt
//  SupplierAnswer.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierAnswer.ts

import {Question } from "./Question";
export class SupplierAnswer {

  // int Id
  public Id: number=0;

  // int SupplierId
  public SupplierId: number=0;

  // int QuestionId
  public QuestionId: number=0;

  // byte? Answer
  public Answer?: number=null;

  // Question Question
  public Question: Question=null;
}